
import { ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { DbInuseResult, TCMRejectionReason, TCMRejectionReasonService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";

export interface TCMRejectionReasonOptions extends ControllerOptions<TCMRejectionReason> {

}


export const initTCMRejectionReason = (inObj: Partial<TCMRejectionReason>): TCMRejectionReason => {
    let item: TCMRejectionReason = {
        color: inObj.color ?? "000000",
        description: inObj.description ?? "",
        name: inObj.name ?? "",
        value: inObj.value ?? "",
        createdBy: ""
    }
    return item;
}


export class ClientTCMRejectionReasonService extends BaseClientService implements DataController<TCMRejectionReason> {

    private _service: TCMRejectionReasonService;


    constructor() {
        super();
        this._service = new TCMRejectionReasonService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMRejectionReasonOptions): Promise<ResultData<TCMRejectionReason>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: TCMRejectionReasonOptions): Promise<ResultData<TCMRejectionReason>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMRejectionReasonOptions): Promise<TCMRejectionReason | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMRejectionReasonOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMRejectionReasonOptions): Promise<TCMRejectionReason | TCMRejectionReason[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMRejectionReasonOptions): Promise<TCMRejectionReason | TCMRejectionReason[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async inUse(options: TCMRejectionReasonOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        }
        throw new Error("ID is required for inUse check");
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async import(options: TCMRejectionReasonOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMRejectionReasonOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}
